import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFolder,
  faFile,
  faFileAlt,
  faFileArchive,
  faFileAudio,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFilePowerpoint,
  faFileVideo,
  faFileWord,
  faInbox,
  faAngleRight,
  faAngleDown
} from "@fortawesome/free-solid-svg-icons";

export function fontSetup() {
  library.add(
    faFolder,
    faFile,
    faFileAlt,
    faFileArchive,
    faFileAudio,
    faFileExcel,
    faFileImage,
    faFilePdf,
    faFilePowerpoint,
    faFileVideo,
    faFileWord,
    faInbox,
    faAngleRight,
    faAngleDown
  );
}




// WEBPACK FOOTER //
// ./src/resources/fontawesome.js